<template>
  <div class="home" id="aboutView">
    <HomeText></HomeText>
  </div>
</template>

<script>
import HomeText from "@/components/HomeComponents/HomeText.vue";
export default {
  name: "HomeView",
  data: () => ({}),
  components: {
    HomeText,
  },
  computed: {},
  methods: {},
};
</script>

<style></style>
